{
  "ADD_NEW_BOOKING_TAB_TITLE": "New Booking",
  "AFTER_SALES_DETAIL_ACCORDION_TITLE_RECOURSE_BOOKINGS": "Bookings",
  "AFTER_SALES_DETAIL_ACCORDION_TITLE_RECOURSE_COST": "Recourse cost",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_BODY_NO_DATA": "There are no additional costs",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_DIALOG_CATEGORY": "Category",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_DIALOG_COMMENT": "Description",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_DIALOG_EUR": "Additional Cost [€]",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_DIALOG_TITLE": "Edit Additional costs",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_HEADER_CATEGORY": "Category",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_HEADER_COMMENT": "Description",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_HEADER_EUR": "Additional Costs [€]",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_SUM": "Additional Costs [€]:",
  "AFTER_SALES_DETAIL_BUTTON_ADDITIONAL_COST": "Additional cost",
  "AFTER_SALES_DETAIL_BUTTON_CREATE_MANUAL_BOOKING": "Create manual booking",
  "AFTER_SALES_DETAIL_CREATE_DATE": "Created on",
  "AFTER_SALES_DETAIL_ERROR_CLASS": "Error class",
  "AFTER_SALES_DETAIL_ERROR_CODE": "Error code",
  "AFTER_SALES_DETAIL_ERROR_DESCRIPTION": "Error description",
  "AFTER_SALES_DETAIL_RECOURSE_COST_RATE": "Recourse cost rate [€]:",
  "AFTER_SALES_DETAIL_RECOURSE_RELEVANT": "Recourse relevant",
  "AFTER_SALES_DETAIL_REPORT_NO": "Complaint No.",
  "AFTER_SALES_DETAIL_REPORT_STATE": "Report state",
  "AFTER_SALES_DETAIL_SUPPLIER": "Supplier number",
  "AFTER_SALES_DETAIL_SUPPLIER_NAME": "Supplier name",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_AMOUNT": "Amount",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_BOOKING_TYPE": "Booking Type",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_CREDITOR": "Creditor",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_CREDITOR_NO": "Creditor No.",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_DUE_DATE": "Due Date",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_ID": "Booking Id",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_STATE": "Status",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_TOTAL_AMOUNT": "Total amount:",
  "AFTER_SALES_DETAIL_TOTAL_COST": "Total recourse costs [€]:",
  "AFTER_SALES_DETAILS_TAB": "Details",
  "AFTER_SALES_ERROR_COST_RATE_CREATE_NEW_BUTTON": "Create error cost rate",
  "AFTER_SALES_ERROR_COST_RATE_DIALOG_COST_RATE_EUR": "Cost rate [€]",
  "AFTER_SALES_ERROR_COST_RATE_DIALOG_ERROR_CLASS": "Error class",
  "AFTER_SALES_ERROR_COST_RATE_DIALOG_ERROR_CODE": "Error code",
  "AFTER_SALES_ERROR_COST_RATE_DIALOG_ERROR_DESC": "Description",
  "AFTER_SALES_ERROR_COST_RATE_DIALOG_TITLE": "Create/Edit error costs rate",
  "AFTER_SALES_ERROR_COST_RATE_TAB": "Error cost rates",
  "AFTER_SALES_OVERVIEW_TAB": "Overview",
  "AFTER_SALES_SUPPLIER_EXCEPTIONS_EXCEL_FILENAME": "Supplier_exceptions",
  "AFTER_SALES_SUPPLIER_EXCEPTIONS_TAB": "Supplier exceptions",
  "AFTER_SALES_TAB": "After Sales",
  "AFTER_SALES_TAB_TITLE": "Overview",
  "AFTER_SALES_TABLE_ADDITIONAL_COST": "Add. Costs",
  "AFTER_SALES_TABLE_CREATE_DATE": "Cr. on",
  "AFTER_SALES_TABLE_DESCRIPTION": "Desc.",
  "AFTER_SALES_TABLE_ERROR_CLASS": "Err. class",
  "AFTER_SALES_TABLE_ERROR_CODE": "Err. code",
  "AFTER_SALES_TABLE_ERROR_COST_ERROR_CLASS": "Error class",
  "AFTER_SALES_TABLE_ERROR_COST_ERROR_DESCRIPTION": "Description",
  "AFTER_SALES_TABLE_ERROR_COST_ERROR_ID": "Error code",
  "AFTER_SALES_TABLE_ERROR_COST_RATE": "Cost rate",
  "AFTER_SALES_TABLE_RECOURSE_COST_RATE": "Rec. cost r.",
  "AFTER_SALES_TABLE_RECOURSE_RELEVANT": "Rec. rel.",
  "AFTER_SALES_TABLE_REPORT_NO": "Compl. No.",
  "AFTER_SALES_TABLE_REPORT_STATE": "Comp.state",
  "AFTER_SALES_TABLE_SUPPLIER": "Supp.",
  "AFTER_SALES_TABLE_SUPPLIER_ID": "Supp. No.",
  "AFTER_SALES_TABLE_TOOLTIP_ADDITIONAL_COST": "Additional Costs",
  "AFTER_SALES_TABLE_TOOLTIP_CREATE_DATE": "Created on",
  "AFTER_SALES_TABLE_TOOLTIP_DESCRIPTION": "Description",
  "AFTER_SALES_TABLE_TOOLTIP_ERROR_CLASS": "Error class",
  "AFTER_SALES_TABLE_TOOLTIP_ERROR_CODE": "Error code",
  "AFTER_SALES_TABLE_TOOLTIP_RECOURSE_COST_RATE": "Recourse cost rate",
  "AFTER_SALES_TABLE_TOOLTIP_RECOURSE_RELEVANT": "Recourse relevant",
  "AFTER_SALES_TABLE_TOOLTIP_REPORT_NO": "Complaint No.",
  "AFTER_SALES_TABLE_TOOLTIP_REPORT_STATE": "Complain state",
  "AFTER_SALES_TABLE_TOOLTIP_SUPPLIER": "Supplier",
  "AFTER_SALES_TABLE_TOOLTIP_SUPPLIER_ID": "Supplier number",
  "AFTER_SALES_TABLE_TOOLTIP_TOTAL_COST": "Total recourse costs",
  "AFTER_SALES_TABLE_TOTAL_COST": "Tot.rec.costs",
  "AFTERSALES": "Aftersales",
  "AG_GRID_NO_ATTACHMENTS": "No attachments available",
  "AG_GRID_NO_BOOKINGS": "No bookings available",
  "AG_GRID_NO_ROWS": "No rows to show",
  "ag-grid.andCondition": "AND",
  "ag-grid.applyFilter": "Apply Filter",
  "ag-grid.area": "Area",
  "ag-grid.areaChart": "Area",
  "ag-grid.areaGroup": "Area",
  "ag-grid.automatic": "Automatic",
  "ag-grid.autosizeAllColumns": "Autosize All Columns",
  "ag-grid.autosizeThiscolumn": "Autosize This Column",
  "ag-grid.avg": "Average",
  "ag-grid.axis": "Axis",
  "ag-grid.background": "Background",
  "ag-grid.barChart": "Bar",
  "ag-grid.barGroup": "Bar",
  "ag-grid.blanks": "Blank",
  "ag-grid.blur": "Blur",
  "ag-grid.bold": "Bold",
  "ag-grid.boldItalic": "Bold Italic",
  "ag-grid.bottom": "Bottom",
  "ag-grid.bubble": "Bubble",
  "ag-grid.bubbleTooltip": "Bubble",
  "ag-grid.callout": "Callout",
  "ag-grid.categories": "Categories",
  "ag-grid.category": "Category",
  "ag-grid.chart": "Chart",
  "ag-grid.chartRange": "Chart Range",
  "ag-grid.clearFilter": "Clear Filter",
  "ag-grid.collapseAll": "Close-em-up",
  "ag-grid.color": "Color",
  "ag-grid.columnChart": "Column",
  "ag-grid.columnGroup": "Column",
  "ag-grid.columns": "Columns",
  "ag-grid.contains": "Contains",
  "ag-grid.copy": "Copy",
  "ag-grid.copyWithHeaders": "Copy With Headers",
  "ag-grid.count": "Count",
  "ag-grid.csvExport": "CSV Exportp",
  "ag-grid.ctrlC": "Ctrl n C",
  "ag-grid.ctrlV": "Ctrl n V",
  "ag-grid.data": "Data",
  "ag-grid.dateFormatOoo": "yyyy-mm-dd",
  "ag-grid.defaultCategory": "(None)",
  "ag-grid.doughnut": "Doughnut",
  "ag-grid.doughnutTooltip": "Doughnut",
  "ag-grid.enabled": "Enabled",
  "ag-grid.endsWith": "Ends with",
  "ag-grid.equals": "Equals",
  "ag-grid.excelExport": "Excel Exporto (.xlsx)",
  "ag-grid.excelXmlExport": "Excel Exporto (.xml)",
  "ag-grid.expandAll": "Open-em-up",
  "ag-grid.export": "Exporto",
  "ag-grid.fillOpacity": "Fill Opacity",
  "ag-grid.filteredRows": "Filtered",
  "ag-grid.filterOoo": "Filter...",
  "ag-grid.filters": "Filters",
  "ag-grid.first": "First",
  "ag-grid.font": "Font",
  "ag-grid.format": "Format",
  "ag-grid.greaterThan": "Greater than",
  "ag-grid.greaterThanOrEqual": "Greater than or equal",
  "ag-grid.group": "Group",
  "ag-grid.groupBy": "Group by",
  "ag-grid.groupedAreaTooltip": "Grouped",
  "ag-grid.groupedBar": "Grouped",
  "ag-grid.groupedBarTooltip": "Grouped",
  "ag-grid.groupedColumn": "Grouped",
  "ag-grid.groupedColumnTooltip": "Grouped",
  "ag-grid.groups": "Row Groups",
  "ag-grid.histogramBinCount": "Bin Count",
  "ag-grid.histogramChart": "Histogram",
  "ag-grid.histogramGroup": "Histogram",
  "ag-grid.histogramTooltip": "Histogram",
  "ag-grid.inRange": "In range",
  "ag-grid.inRangeEnd": "Till",
  "ag-grid.inRangeStart": "From",
  "ag-grid.italic": "Italic",
  "ag-grid.itemPaddingX": "Item Padding X",
  "ag-grid.itemPaddingY": "Item Padding Y",
  "ag-grid.labels": "Labels",
  "ag-grid.last": "Last",
  "ag-grid.left": "Left",
  "ag-grid.legend": "Legend",
  "ag-grid.length": "Length",
  "ag-grid.lessThan": "Less than",
  "ag-grid.lessThanOrEqual": "Less than or equal",
  "ag-grid.line": "Line",
  "ag-grid.lineGroup": "Line",
  "ag-grid.lineTooltip": "Line",
  "ag-grid.lineWidth": "Line Width",
  "ag-grid.loadingOoo": "Loading...",
  "ag-grid.markerPadding": "Marker Padding",
  "ag-grid.markers": "Markers",
  "ag-grid.markerSize": "Marker Size",
  "ag-grid.markerStroke": "Marker Stroke",
  "ag-grid.max": "Max",
  "ag-grid.maxSize": "Maximum Size",
  "ag-grid.min": "Min",
  "ag-grid.minSize": "Minimum Size",
  "ag-grid.more": "More",
  "ag-grid.next": "Next",
  "ag-grid.noDataToChart": "No data available to be charted.",
  "ag-grid.none": "None",
  "ag-grid.noPin": "No Pin",
  "ag-grid.normal": "Normal",
  "ag-grid.normalizedArea": "100% Stacked",
  "ag-grid.normalizedAreaTooltip": "100% Stacked",
  "ag-grid.normalizedBar": "100% Stacked",
  "ag-grid.normalizedBarTooltip": "100% Stacked",
  "ag-grid.normalizedColumn": "100% Stacked",
  "ag-grid.normalizedColumnTooltip": "100% Stacked",
  "ag-grid.noRowsToShow": " no rows",
  "ag-grid.notContains": "Not contains",
  "ag-grid.notEqual": "Not equal",
  "ag-grid.number": "Number",
  "ag-grid.of": "of",
  "ag-grid.offset": "Offset",
  "ag-grid.offsets": "Offsets",
  "ag-grid.orCondition": "OR",
  "ag-grid.padding": "Padding",
  "ag-grid.page": "Page",
  "ag-grid.paired": "Paired Mode",
  "ag-grid.paste": "Paste",
  "ag-grid.pie": "Pie",
  "ag-grid.pieChart": "Pie",
  "ag-grid.pieGroup": "Pie",
  "ag-grid.pieTooltip": "Pie",
  "ag-grid.pinColumn": "Pin Column",
  "ag-grid.pinLeft": "Pin Left",
  "ag-grid.pinRight": "Pin Right",
  "ag-grid.pivotChart": "Pivot Chart",
  "ag-grid.pivotChartAndPivotMode": "Pivot Chart & Pivot Mode",
  "ag-grid.pivotChartRequiresPivotMode": "Pivot Chart requires Pivot Mode enabled.",
  "ag-grid.pivotChartTitle": "Pivot Chart",
  "ag-grid.pivotColumnsEmptyMessage": "Drag here to set column labels",
  "ag-grid.pivotMode": "Pivot-Mode",
  "ag-grid.pivots": "Column Labels",
  "ag-grid.position": "Position",
  "ag-grid.predefined": "Predefined",
  "ag-grid.previous": "Previous",
  "ag-grid.rangeChartTitle": "Range Chart",
  "ag-grid.rangeEnd": "To",
  "ag-grid.rangeStart": "From",
  "ag-grid.resetColumns": "Reset Columns",
  "ag-grid.resetFilter": "Reset Filter",
  "ag-grid.right": "Right",
  "ag-grid.rowGroupColumns": "Pivot Cols",
  "ag-grid.rowGroupColumnsEmptyMessage": "Drag here to set row groups",
  "ag-grid.scatter": "Scatter",
  "ag-grid.scatterGroup": "Scatter",
  "ag-grid.scatterTooltip": "Scatter",
  "ag-grid.searchOoo": "Search...",
  "ag-grid.selectAll": "Select All",
  "ag-grid.selectedRows": "Selected",
  "ag-grid.series": "Series",
  "ag-grid.settings": "Settings",
  "ag-grid.shadow": "Shadow",
  "ag-grid.size": "Size",
  "ag-grid.stackedArea": "Stacked",
  "ag-grid.stackedAreaTooltip": "Stacked",
  "ag-grid.stackedBar": "Stacked",
  "ag-grid.stackedBarTooltip": "Stacked",
  "ag-grid.stackedColumn": "Stacked",
  "ag-grid.stackedColumnTooltip": "Stacked",
  "ag-grid.startsWith": "Starts with",
  "ag-grid.strokeOpacity": "Line Opacity",
  "ag-grid.strokeWidth": "Stroke Width",
  "ag-grid.sum": "Sum",
  "ag-grid.thickness": "Thickness",
  "ag-grid.ticks": "Ticks",
  "ag-grid.time": "Time",
  "ag-grid.title": "Title",
  "ag-grid.to": "to",
  "ag-grid.toolPanel": "Tool Panelo",
  "ag-grid.toolPanelButton": " tool panel",
  "ag-grid.tooltips": "Tooltips",
  "ag-grid.top": "Top",
  "ag-grid.totalAndFilteredRows": "Rows",
  "ag-grid.totalRows": "Total Rows",
  "ag-grid.ungroupBy": "UnGroup by",
  "ag-grid.valueAggregation": "Value Agg",
  "ag-grid.valueColumns": "Value Cols",
  "ag-grid.valueColumnsEmptyMessage": " drag cols to aggregate",
  "ag-grid.values": "Values",
  "ag-grid.width": "Width",
  "ag-grid.xOffset": "X Offset",
  "ag-grid.xRotation": "X Rotation",
  "ag-grid.xType": "X Type",
  "ag-grid.xyChart": "X Y (Scatter)",
  "ag-grid.xyValues": "X Y Values",
  "ag-grid.yOffset": "Y Offset",
  "ag-grid.yRotation": "Y Rotation",
  "APP_TITLE": "TuR Recourse Cockpit",
  "APPROVAL_BOOKING_FAILED": "Booking {{0}} could not be approved.",
  "APPROVAL_BOOKING_SUCCESSFUL": "Booking {{0}} is successfully approved.",
  "APPROVAL_PROCESS_CONFIRMDIALOG_MESSAGE": "Booking will be saved and approvement process will be started. Are you sure to start the approvement process?",
  "APPROVAL_PROCESS_CONFIRMDIALOG_TITLE": "Start Approvement process",
  "APPROVAL_PROCESS_FAILED_MESSAGE": "Approval workflow could not be saved",
  "APPROVAL_PROCESS_FAILED_TITLE": "Approval workflow failed",
  "APPROVAL_PROCESS_STARTED_SUCCESSFUL": "Approvement process successfully started",
  "APPROVAL_PROCESS_TITLE": "Approvement process started",
  "APPROVAL_TAB": "Approvals",
  "APPROVAL_TAB_TITLE": "Overview",
  "APPROVAL_TABLE_AMOUNT": "Net",
  "APPROVAL_TABLE_APPROVE_BUTTON": "Approve",
  "APPROVAL_TABLE_BOOKING_ID": "ID",
  "APPROVAL_TABLE_BOOKING_TYPE": "Book. type",
  "APPROVAL_TABLE_CREATE_DATE": "Cr. on",
  "APPROVAL_TABLE_CREATOR": "Ed.",
  "APPROVAL_TABLE_DEBITOR_ID": "Deb. No.",
  "APPROVAL_TABLE_DETAILS_BUTTON": "Details",
  "APPROVAL_TABLE_INVOICE_REASON": "Inv. reason",
  "APPROVAL_TABLE_RECOURSE_TYPE": "Rec. type",
  "APPROVAL_TABLE_REJECT_BUTTON": "Reject",
  "APPROVAL_TABLE_SUPPLIER": "Cred.",
  "APPROVAL_TABLE_SUPPLIER_ID": "Cred. No.",
  "APPROVAL_TABLE_TOOLTIP_AMOUNT": "Net amount",
  "APPROVAL_TABLE_TOOLTIP_BOOKING_ID": "Booking ID",
  "APPROVAL_TABLE_TOOLTIP_BOOKING_TYPE": "Booking type",
  "APPROVAL_TABLE_TOOLTIP_CREATE_DATE": "Created on",
  "APPROVAL_TABLE_TOOLTIP_CREATOR": "Editor",
  "APPROVAL_TABLE_TOOLTIP_DEBITOR_ID": "Debitor No.",
  "APPROVAL_TABLE_TOOLTIP_INVOICE_REASON": "Invoice reason",
  "APPROVAL_TABLE_TOOLTIP_RECOURSE_TYPE": "Recourse type",
  "APPROVAL_TABLE_TOOLTIP_SUPPLIER": "Creditor",
  "APPROVAL_TABLE_TOOLTIP_SUPPLIER_ID": "Creditor No.",
  "APPROVAL_WORKFLOW_BOOKING_FAILED": "Approval process for booking/s {{0}} could not be started.",
  "APPROVAL_WORKFLOW_BOOKING_SUCCESSFUL": "Booking/s {{0}} will be saved and approval process will be started.",
  "APPROVE_AUTOMATED_AFTERSALES_BOOKINGS": "Approve all autom. bookings",
  "APPROVE_AUTOMATED_BOOKINGS_DIALOG_MESSAGE": "Do you really want to approve {{0}} automated {{1}} bookings?",
  "APPROVE_AUTOMATED_BOOKINGS_FAILED_MESSAGE": "Failed to approve {{0}} bookings.",
  "APPROVE_AUTOMATED_BOOKINGS_SUCCESS_MESSAGE": "{{0}} bookings successfully approved.",
  "APPROVE_AUTOMATED_RECOURSE_BOOKINGS": "Approve debit note run",
  "APPROVE_BOOKING_FAILED_MESSAGE": "Approval failed: Booking {{0}} could not be approved.",
  "APPROVE_BOOKING_FAILED_TITLE": "Approval failed",
  "APPROVE_BOOKING_MESSAGE": "Booking approved: Booking {{0}} successfully approved.",
  "APPROVE_BOOKING_TITLE": "Booking approved",
  "APPROVE_DIALOG_MESSAGE": "Do you really want to approve the booking?",
  "APPROVE_DIALOG_TITLE": "Really approve the booking?",
  "APPROVED": "Approved",
  "ATTACHMENT_CAN_NOT_BE_SAVED": "Attachment cannot be removed",
  "ATTACHMENT_CAN_NOT_BE_SAVED_MESSAGE": "Due to the current campaign status, this attachment cannot be removed.",
  "ATTACHMENTS_CREATOR": "Creator",
  "ATTACHMENTS_DATE": "Date",
  "ATTACHMENTS_FILE_NAME": "Filename",
  "ATTACHMENTS_RECEIVER": "Receiver",
  "AUTHENTICITY_AUDIT_REPORT_ADDITIONAL_COSTS_FAILED": "The verification of the Additional Costs for the Recourse Audit Report {{0}} failed, please contact immediately your system administrator",
  "AUTHENTICITY_AUDIT_REPORT_ADDITIONAL_COSTS_FAILED_TITLE": "Verification of Audit Report Additional Costs failed",
  "AUTHENTICITY_AUDIT_REPORT_FAILED": "The verification of the Recourse Audit Report {{0}} failed, please contact immediately your system administrator",
  "AUTHENTICITY_AUDIT_REPORT_FAILED_TITLE": "Verification of Recourse Audit Report failed",
  "AUTHENTICITY_ERROR_COST_RATE_FAILED": "Verification of error cost rates {{0}} failed",
  "AUTHENTICITY_ERROR_COST_RATE_FAILED_LONG": "The verification of the Error Cost Rates for the Recourse Audit Report {{0}} failed, please contact immediately your system administrator",
  "AUTHENTICITY_ERROR_COST_RATE_FAILED_TITLE": "Verification of Error Cost Rates failed",
  "AUTHENTICITY_FILE_CHECKSUM_FAILED_TITLE": "Verification of the checksum from the file failed",
  "AUTHENTICITY_FILE_FAILED_TITLE": "Verification of file failed",
  "AUTHENTICITY_RECOURSE_BOOKING_ATTACHMENTS_FAILED_TITLE": "Verification of Attachments failed",
  "AUTHENTICITY_RECOURSE_BOOKING_FAILED_TITLE": "Verification of Recourse Booking failed",
  "BLOCKED": "Blocked",
  "BOOKED": "Booked",
  "BOOKING_APPROVAL_HISTORY": "History",
  "BOOKING_APPROVAL_HISTORY_ACTION": "Action",
  "BOOKING_APPROVAL_HISTORY_DATE": "Date",
  "BOOKING_APPROVAL_HISTORY_EDITOR": "Editor",
  "BOOKING_APPROVAL_HISTORY_NO_VALUES": "No values available",
  "BOOKING_APPROVAL_HISTORY_STEP": "Step",
  "BOOKING_APPROVAL_HISTORY_TIME": "Time",
  "BOOKING_APPROVAL_REQUESTED": "Booking approval requested",
  "BOOKING_BLOCKED": "Booking blocked",
  "BOOKING_BLOCKED_ACTION": "Customer invalid - Booking blocked",
  "BOOKING_BOOKED_ACTION": "Booking transferred to SAP",
  "BOOKING_CANCELLED": "Booking cancelled",
  "BOOKING_CANCELLED_ACTION": "Booking cancelled",
  "BOOKING_CREATED": "Booking created",
  "BOOKING_CREATED_ACTION": "Booking created",
  "BOOKING_DETAILS_ADDRESS": "Address",
  "BOOKING_DETAILS_APPROVE_BOOKING": "Approve booking",
  "BOOKING_DETAILS_ATTACHMENTS": "Attachments",
  "BOOKING_DETAILS_ATTACHMENTS_CREATOR": "Creator",
  "BOOKING_DETAILS_ATTACHMENTS_DATE": "Date",
  "BOOKING_DETAILS_ATTACHMENTS_FILE_NAME": "File name",
  "BOOKING_DETAILS_ATTACHMENTS_RECEIVER": "Receiver",
  "BOOKING_DETAILS_BOOKING_JUSTIFICATION_COMMENT": "Reason for booking",
  "BOOKING_DETAILS_BOOKING_TYPE": "Booking type",
  "BOOKING_DETAILS_CITY": "City",
  "BOOKING_DETAILS_COMMENT_CHARACTER_LEFT": "Character left:",
  "BOOKING_DETAILS_CREATE_CORRECTION_BOOKING": "Create correction booking",
  "BOOKING_DETAILS_CREATE_MANUAL_BOOKING": "Create manual booking",
  "BOOKING_DETAILS_CREATED_ON": "Created on",
  "BOOKING_DETAILS_CREATOR": "Creator",
  "BOOKING_DETAILS_CURRENCY": "Currency",
  "BOOKING_DETAILS_DEBITOR": "Debitor",
  "BOOKING_DETAILS_DIALOG_FAILED_MESSAGE": "Please contact your key user. The document for Booking {{0}} must be manually deleted in SAP.",
  "BOOKING_DETAILS_DIALOG_FAILED_TITLE": "Attention: Booking failed",
  "BOOKING_DETAILS_DUE_DATE": "Due Date",
  "BOOKING_DETAILS_EXTERNAL_RECEIVER": "External receiver",
  "BOOKING_DETAILS_GENERAL_INFO": "General information",
  "BOOKING_DETAILS_ID": "Booking ID",
  "BOOKING_DETAILS_INVOICE_REASON": "Invoice reason",
  "BOOKING_DETAILS_NAME": "Name",
  "BOOKING_DETAILS_NET_AMOUNT": "Net amount",
  "BOOKING_DETAILS_NO_ATTACHMENTS_MESSAGE": "No attachments available",
  "BOOKING_DETAILS_PARTIAL_PAYMENT": "Partial payment",
  "BOOKING_DETAILS_POST_OFFICE_BOX": "Post office box",
  "BOOKING_DETAILS_POSTAL_CODE": "Postal code",
  "BOOKING_DETAILS_POSTAL_CODE_PO_BOX": "Postal code PO box",
  "BOOKING_DETAILS_RECOURSE_TYPE": "Recourse type",
  "BOOKING_DETAILS_REJECT_BOOKING": "Reject booking",
  "BOOKING_DETAILS_REPROCESS": "Reprocess",
  "BOOKING_DETAILS_REVENUE_ORDER_NUMBER": "Revenue order number",
  "BOOKING_DETAILS_STATE": "State",
  "BOOKING_DETAILS_STATUS": "Status",
  "BOOKING_DETAILS_STREET_ADDRESS": "Street address",
  "BOOKING_DETAILS_SUPPLIER": "Creditor",
  "BOOKING_DETAILS_TAB_TITLE": "Details",
  "BOOKING_DETAILS_TOTAL_CALCULATED_AMOUNT": "Total net amount:",
  "BOOKING_FAILED_ACTION": "Transfer to SAP failed",
  "BOOKING_IN_INTERNAL_APPROVAL": "Booking in internal approval",
  "BOOKING_INTERNAL_APPROVED": "Booking internal approved",
  "BOOKING_IS_BOOKED": "Booking is booked",
  "BOOKING_IS_PRINTED": "Booking is printed",
  "booleanToYesNo.false": "no",
  "booleanToYesNo.true": "yes",
  "BUILD_DATE": "Build Date",
  "BUILD_VERSION": "Version",
  "CAMPAIGN": "Campaign",
  "CAMPAIGN_DETAILS": "Details",
  "CAMPAIGN_DETAILS_GENERAL_INFO": "General information",
  "CAMPAING_DETAILS_MESSAGE_2": "Precondition for new state not fulfilled. State cannot be set. Publish date and mandatory fields must be filled.",
  "CAMPAING_DETAILS_MESSAGE_3": "Precondition for new state not fulfilled. State cannot be set. Complaint date and one attachment much exist.",
  "CAMPAING_DETAILS_MESSAGE_4": "Precondition for new state not fulfilled. State cannot be set. Recourse claim date and one attachment must exist.",
  "CAMPAING_DETAILS_MESSAGE_5": "Precondition for new state not fulfilled. State cannot be set. Negotiation date and one attachment must exist.",
  "CAMPAING_DETAILS_MESSAGE_6": "Precondition for new state not fulfilled. State cannot be set. At least one booking to this campaign must exist.",
  "CANCEL": "Cancel",
  "CANCEL_BOOKING_BUTTON": "Cancel booking",
  "CANCEL_BOOKING_FAILED": "Booking {{0}} could not ne cancelled.",
  "CANCEL_BOOKING_MESSAGE": "Booking will be cancelled and changes are not saved. Do you still want to continue?",
  "CANCEL_BOOKING_SUCCESSFUL": "Booking {{0}} is successfully cancelled.",
  "CANCEL_BOOKING_TITLE": "Cancel booking",
  "CANCELLED": "Cancelled",
  "CANCELLED_STOPPED_CHANGED": "Canceled/Stopped/Changed",
  "CENTRAL_BOOKING_BLOCK": "Debitor is blocked for bookings",
  "CENTRAL_INVOICE_BLOCK": "Debitor is blocked for invoices",
  "CENTRAL_ORDER_BLOCK": "Debitor is blocked for orders",
  "CHANGE_OF_STATE": "Change of State",
  "CHOOSE_ONE": "Choose one",
  "COMMENT_INVOICE_REASON": "Comment invoice reason",
  "COMPANY_CODE_BLOCK": "Debitor is blocked for bookings for company code",
  "COMPLAINT": "Complaint",
  "COMPLAINT_DATE_OF_DISPATCH": "Complaint sent",
  "COMPLETED": "Completed",
  "COMPLETELY_BOOKED": "Completely booked",
  "COMPONENT_MARKING": "Component marking",
  "CONFIRM": "Confirm",
  "CREATOR_APPROVED_ACTION": "Creator approved/ Submitted for approval",
  "CREDIT": "Credit",
  "CREDIT_BOOKING_APPROVED": "Credit booking approved",
  "CREDIT_BOOKING_REJECTED": "Credit booking rejected",
  "dateFormat": "dd.MM.yyyy",
  "DEBIT": "Debit",
  "DEFAULT_VIEW": "Default View",
  "DELETE_ADDITIONAL_COST_FAILED": "Additional cost {{0}} for Audit report {{1}} could not be deleted.",
  "DELETE_ADDITIONAL_COST_MESSAGE": "Do you really want to delete the following additional costs? <br><br>Category: {{0}} <br>Description: {{1}} <br>Additional costs [€]: {{2}}",
  "DELETE_ADDITIONAL_COST_SUCCESSFUL": "Additional cost {{0}} for Audit report {{1}} is successfully deleted.",
  "DELETE_ADDITIONAL_COST_TITLE": "Delete additional costs",
  "DELETE_ATTACHMENT_FAILED": "Attachment {{0}} could not be deleted.",
  "DELETE_ATTACHMENT_MESSAGE": "Do you really want to delete the attachment?",
  "DELETE_ATTACHMENT_SUCCESSFUL": "Attachment {{0}} is successfully deleted.",
  "DELETE_ATTACHMENT_TITLE": "Delete attachment",
  "DELETE_FILE_FAILED_TITLE": "Delete failed",
  "DOWNLOAD_ATTACHMENT_FAILED": "Attachment {{0}} could not be downloaded.",
  "DOWNLOAD_FAILED_TITLE": "Download failed",
  "DUE_DATE_REVENUES": "Revenues set",
  "DUPLICATE_CAMPAIGN": "Duplicate campaign",
  "DUPLICATE_CAMPAIGN_ERROR_MESSAGE": "Campaign could not be duplicated.",
  "DUPLICATE_CAMPAIGN_ERROR_TITLE": "Error creating campaign {{0}} duplicate",
  "DUPLICATE_CAMPAIGN_OPERATION_ID": "Operation ID",
  "DUPLICATE_CAMPAIGN_SUCCESS_MESSAGE": "Campaign is successfully duplicated.",
  "DUPLICATE_CAMPAIGN_SUCCESS_TITLE": "Campaign {{0}} duplicated",
  "EDIT_BOOKING_TAB_TITLE": "Edit",
  "ERROR_CODE_0000": "A network occurred",
  "ERROR_CODE_1000": "Unknown language",
  "ERROR_CODE_2000": "Message is missing",
  "ERROR_CODE_2001": "Log-level is missing",
  "ERROR_CODE_2002": "Client's date is missing",
  "ERROR_CODE_3000": "User has no permission for this action",
  "ERROR_CODE_3001": "User does not have read permission",
  "ERROR_CODE_3002": "User does not have approval permission",
  "ERROR_CODE_3003": "User does not have booking permission",
  "ERROR_CODE_3004": "User does not have campaigns workflow permission",
  "ERROR_CODE_4000": "Validation failed for: {{0}}",
  "ERROR_CODE_4001": "Concurrency error",
  "ERROR_CODE_5000": "Recourse Booking not found for booking id={{0}}",
  "ERROR_CODE_6001": "Supplier not found for no={{{0}}}",
  "ERROR_CODE_7000": "Original filename argument is null",
  "ERROR_CODE_7001": "Failed to store empty file",
  "ERROR_CODE_7002": "The attachment has an invalid filename.",
  "ERROR_CODE_7003": "Failed to read file",
  "ERROR_CODE_7004": "Failed to find file",
  "ERROR_CODE_7005": "Download failed",
  "ERROR_CODE_7006": "Failed to generate md5 checksum",
  "ERROR_CODE_7007": "Failed to save file because of no reference to a recourse booking",
  "ERROR_CODE_7008": "Delete file failed",
  "ERROR_CODE_7100": "Upload failed",
  "ERROR_CODE_8000": "Verification failed",
  "ERROR_CODE_8002": "The verification of the checksum from the file{{0}} - {{1}} failed, please contact immediately your system administrator",
  "ERROR_CODE_8003": "The verification of the Attachment {{0}} failed, attachment {{0}} - {{1}} is corrupted, please contact immediately your system administrator",
  "ERROR_CODE_8004": "The verification of the Recourse Booking {{0}} failed, please contact immediately your system administrator",
  "ERROR_CODE_8005": "The verification of the Attachments from the Recourse Booking {{0}} failed, please contact immediately your system administrator",
  "ERROR_COST_RATE_CLASS_A": "A",
  "ERROR_COST_RATE_CLASS_B": "B",
  "EXCEL_EXPORT": "Excel export",
  "EXCEL_EXPORT_AFTER_SALES_OVERVIEW": "After Sales - After sales overview",
  "EXCEL_EXPORT_APPROVAL_OVERVIEW": "Approval - Approval overview",
  "EXCEL_EXPORT_BOOKING_OVERVIEW": "Overview - Booking overview",
  "EXCEL_EXPORT_CAMPAIGN_RECOURSE_OVERVIEW": "Campaing recourse - Campaign recourse overview",
  "EXCEL_EXPORT_CONFIDENTIAL": "Confidential",
  "EXCEL_EXPORT_CONFIDENTIAL_LEVEL": "Confidential level:",
  "EXCEL_EXPORT_DATE": "Date:",
  "EXCEL_EXPORT_ERROR_CONTENT": "An error occured while generating the excel file.",
  "EXCEL_EXPORT_ERROR_TITLE": "Failed to generate excel",
  "EXPLICIT_PAYMENT_TARGET": "Set explicit payment date",
  "EXTERNAL": "External",
  "FAILED": "Booking failed",
  "FIELD_MASTER_DATA_TAB": "Field Master Data",
  "FILTER_SEARCH_CRITERIA": "Filter Search Criteria",
  "FORM_CONTAINS_UNSAVED_DATA_MESSAGE": "Form contains unsaved changes. Do you still want to continue?",
  "FORM_CONTAINS_UNSAVED_DATA_TITLE": "Form contains unsaved changes",
  "GENERAL_DATA": "General Data",
  "IN_APPROVAL": "In Approval",
  "IN_NEGOTIATION": "In negotiation",
  "IN_PROGRESS": "In Progress",
  "INSOLVENCY_FLAG": "Debitor is insolvent",
  "INTERNAL": "Internal",
  "INTERNAL_APPROVED_ACTION": "Internal approved",
  "INTERNAL_FAULT": "Internal fault",
  "INTERNAL_REJECTED_ACTION": "Internal rejected",
  "INVOICE_REASON_TEXT_CORRECTION_BOOKING": "Credit to:",
  "LBL_ALL": "All",
  "LBL_ALL_WITH": "All (filtered)",
  "NEGOTIATED": "Negotiated",
  "NEGOTIATION": "Negotiation",
  "NETWORK_ERROR_TITLE": "Network error",
  "NEW_CAMPAIGN": "New Campaign",
  "NO": "No",
  "NO_CUSTOMER_AVAILABLE": "No Debitor available",
  "NO_REFERENCED_BOOKINGS_AVAILABLE": "No references available",
  "NO_SUPPLIER_FAULT": "No supplier fault",
  "noDataFound": "No data found",
  "noMatchingRows": "No matching rows",
  "NOTIFICATION_DELETE_MISC_ERROR_HEADER": "Error during deletion",
  "NOTIFICATION_DELETE_MISC_ERROR_MESSAGE": "Deletion process not executed",
  "NOTIFICATION_DELETE_MISC_SUCCESS_HEADER": "Delete successful",
  "NOTIFICATION_DELETE_MISC_SUCCESS_MESSAGE": "Deletion was executed successfully",
  "NOTIFICATION_SAVE_ERROR_HEADER": "Error on saving",
  "NOTIFICATION_SAVE_ERROR_MESSAGE": "Changes were not saved",
  "NOTIFICATION_SAVE_ERROR_MESSAGE_REASON_PERMISSON": "User does not have sufficient permissions",
  "NOTIFICATION_UNEXPECTED_ERROR_HEADER": "Unexpected Error",
  "NOTIFICATION_UNEXPECTED_ERROR_MESSAGE": "Please contact service",
  "objectCriteria.1": "1 new vehicle warranty",
  "objectCriteria.2": "2 spare part",
  "objectCriteria.5": "5 paint warranty",
  "objectCriteria.7": "7 campaign",
  "objectCriteria.8": "8 spare part from stock",
  "objectCriteria.9": "9 long term warranty",
  "objectCriteria.E": "E emission warranty",
  "objectCriteria.G": "G used car warranty",
  "objectCriteriaGroup.SERIES": "Series",
  "objectCriteriaGroup.SPARE_PART": "Spare Part",
  "objectCriteriaGroup.WILD_CARD": "*",
  "OK": "OK",
  "OPEN": "Open",
  "PACKAGE_MARKING": "Package marking",
  "PACKAGING_QUALITY": "Packaging quality",
  "partsAgreement.add.btnCancel": "Cancel",
  "partsAgreement.add.btnSave": "Save",
  "partsAgreement.add.comment": "Comment",
  "partsAgreement.add.commentCharacterLeft": "Character left:",
  "partsAgreement.add.errorCode15009": "Too many overlaps with existing data set",
  "partsAgreement.add.modelYearFormat": "Format YYYY expected!",
  "partsAgreement.add.modelYearNotAllowed": "From to not valid!",
  "partsAgreement.add.orderTypeValidation": "Length between 3 - 6 characters!",
  "partsAgreement.add.partNumberValidation": "Length between 9 - 11 characters!",
  "partsAgreement.add.supplierCity": "City",
  "partsAgreement.add.tab": "New Parts Agreement",
  "partsAgreement.add.technicalFactorValidation": "Number between 0 - 100!",
  "partsAgreement.add.validationCurrentDate": "Value must be greater/equal to current date!",
  "partsAgreement.add.validatorInvalidCharacters": "Invalid character",
  "partsAgreement.comment": "Comment",
  "partsAgreement.commentInvalidCharacters": "{ } characters are not allowed. < > are only allowed around mail addresses.",
  "partsAgreement.edit": "Edit Parts Agreement",
  "partsAgreement.httpCode200": "Item saved successfully. Id: {{0}} ",
  "partsAgreement.id": "ID",
  "partsAgreement.modelYearFrom": "Model Year (from)",
  "partsAgreement.modelYearFromShort": "MY (from)",
  "partsAgreement.modelYearTo": "Model Year (to)",
  "partsAgreement.modelYearToShort": "MY (to)",
  "partsAgreement.orderType": "Order Type",
  "partsAgreement.orderTypeShort": "Order t.",
  "partsAgreement.productionDateFrom": "Production Date (from)",
  "partsAgreement.productionDateFromShort": "ZP8 (from)",
  "partsAgreement.productionDateTo": "Production Date (to)",
  "partsAgreement.productionDateToShort": "ZP8 (to)",
  "partsAgreement.sparePartNumber": "Spare Part Number",
  "partsAgreement.sparePartNumberShort": "Spare Part Nr.",
  "partsAgreement.supplierName": "Supplier Name",
  "partsAgreement.supplierNameShort": "Name",
  "partsAgreement.supplierNumber": "Supplier Number",
  "partsAgreement.supplierNumberShort": "Supplier",
  "partsAgreement.saveError.content": "Error saving parts agreement",
  "partsAgreement.saveError.title": "Error",
  "partsAgreement.saveSuccess.content": "Parts agreement saved successfully",
  "partsAgreement.saveSuccess.title": "Success",
  "partsAgreement.tab": "Parts Agreement",
  "partsAgreement.technicalFactor": "Technical Factor [%]",
  "partsAgreement.technicalFactorShort": "TF",
  "partsAgreement.validityDateFrom": "Validity Date (from)",
  "partsAgreement.validityDateFromShort": "Valid (from)",
  "partsAgreement.validityDateTo": "Validity Date (to)",
  "partsAgreement.validityDateToShort": "Valid (to)",
  "partsAgreementsOverview.btnAdd": "Add Parts Agreement",
  "PREPARE_DATA": "Prepare data",
  "PUBLISH_DATE": "Published campaign",
  "RAD": "Research & Development",
  "recourceCriteria.add": "Add recourse criteria",
  "recourceCriteria.saveError.content": "Error when saving recourse criteria",
  "recourceCriteria.saveError.overlap": "A recourse criteria with identical part number, supplier number, dealer number, object criteria group and an overlapping validity period already exists.",
  "recourceCriteria.saveError.title": "Error",
  "recourceCriteria.saveSuccess.content": "Recourse Criteria saved",
  "recourceCriteria.saveSuccess.title": "Success",
  "RECOURSE": "GuK Recourse",
  "RECOURSE_AUDIT_REPORT_STATE_CANCELLED": "Cancelled",
  "RECOURSE_AUDIT_REPORT_STATE_CLOSED": "Closed",
  "RECOURSE_AUDIT_REPORT_STATE_OPEN": "Open",
  "RECOURSE_BOOKING_TAB": "Bookings",
  "RECOURSE_BOOKING_TAB_TITLE": "Overview",
  "RECOURSE_BOOKING_TABLE_ANGELEGT_AM": "Cr. on",
  "RECOURSE_BOOKING_TABLE_BELEG_NR": "ID",
  "RECOURSE_BOOKING_TABLE_BOOKING_TYPE": "Book. type",
  "RECOURSE_BOOKING_TABLE_CREATION_TYPE": "Cr.",
  "RECOURSE_BOOKING_TABLE_DEBITOR_NR": "Deb. No.",
  "RECOURSE_BOOKING_TABLE_DUE_DATE": "Due date - Booking date",
  "RECOURSE_BOOKING_TABLE_ERSTELLER": "Ed.",
  "RECOURSE_BOOKING_TABLE_FAKTURAGRUND": "Inv. reason",
  "RECOURSE_BOOKING_TABLE_LIEFERANT": "Cred.",
  "RECOURSE_BOOKING_TABLE_LIEFERANT_NR": "Cred. No.",
  "RECOURSE_BOOKING_TABLE_NETTOWERT": "Net",
  "RECOURSE_BOOKING_TABLE_RECOURSE_TYPE": "Rec. type",
  "RECOURSE_BOOKING_TABLE_REVENUE_ORDER_NUMBER": "Rev.Ord.No.",
  "RECOURSE_BOOKING_TABLE_STATUS": "State",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_ANGELEGT_AM": "Created on",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_BELEG_NR": "Booking ID",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_BOOKING_TYPE": "Booking type",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_CREATION_TYPE": "Creation",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_DEBITOR_NR": "Debitor No.",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_DUE_DATE": "Due-/Book Date",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_ERSTELLER": "Editor",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_FAKTURAGRUND": "Invoice reason",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_LIEFERANT": "Creditor",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_LIEFERANT_NR": "Creditor No.",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_NETTOWERT": "Net amount",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_RECOURSE_TYPE": "Recourse type",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_REVENUE_ORDER_NUMBER": "Revenue order number",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_STATUS": "State",
  "RECOURSE_CAMPAIGN_DETAIL_AFFECTED_MARKETS": "Affected markets",
  "RECOURSE_CAMPAIGN_DETAIL_AFFECTED_VEHICLES": "Affected vehicles",
  "RECOURSE_CAMPAIGN_DETAIL_ASSIGNEE": "Assignee",
  "RECOURSE_CAMPAIGN_DETAIL_BOOKINGS": "Bookings",
  "RECOURSE_CAMPAIGN_DETAIL_CAMPAIGN_COSTS": "Prognosis costs(target)[€]",
  "RECOURSE_CAMPAIGN_DETAIL_CAMPAIGN_COSTS_ACTUAL": "Campaign costs(actual)[€]",
  "RECOURSE_CAMPAIGN_DETAIL_CAMPAIGN_COSTS_PROGNOSIS": "Campaign costs(exp.)(100%)[€]",
  "RECOURSE_CAMPAIGN_DETAIL_CAMPAIGN_RECOURSE_ID": "Campaign recourse Id",
  "RECOURSE_CAMPAIGN_DETAIL_CHANGE_DATE": "Change date",
  "RECOURSE_CAMPAIGN_DETAIL_COMPLAINT": "Complaint",
  "RECOURSE_CAMPAIGN_DETAIL_COMPLAINT_CHANGE_DATE": "Change date",
  "RECOURSE_CAMPAIGN_DETAIL_CREATION_DATE": "Creation date",
  "RECOURSE_CAMPAIGN_DETAIL_DIALOG_CAUSE_OF_REJECTION": "Cause of rejection",
  "RECOURSE_CAMPAIGN_DETAIL_DIALOG_INVALID_ASSIGNEE_MESSAGE": "Invalid assignee. Please select a valid assignee.",
  "RECOURSE_CAMPAIGN_DETAIL_DIALOG_INVALID_ASSIGNEE_TITLE": "Invalid assignee",
  "RECOURSE_CAMPAIGN_DETAIL_EXAMINATION_REGRESS_E_P": "Examination regress e/p",
  "RECOURSE_CAMPAIGN_DETAIL_EXTERNAL_CONTACT": "External contact",
  "RECOURSE_CAMPAIGN_DETAIL_FKCAMPAIGN_STATE_ID": "State",
  "RECOURSE_CAMPAIGN_DETAIL_FULFILLMENT_DEGREE": "Fulfillment degree[%]",
  "RECOURSE_CAMPAIGN_DETAIL_GENERAL_INFO": "General info",
  "RECOURSE_CAMPAIGN_DETAIL_INTERNAL_CONTACT": "Internal contact",
  "RECOURSE_CAMPAIGN_DETAIL_NAME1": "Creditor",
  "RECOURSE_CAMPAIGN_DETAIL_NEGOTIATION": "Negotiation",
  "RECOURSE_CAMPAIGN_DETAIL_NEGOTIATION_CHANGE_DATE": "Change date",
  "RECOURSE_CAMPAIGN_DETAIL_NOTE": "Note",
  "RECOURSE_CAMPAIGN_DETAIL_OPERATION_ID": "Operation Id",
  "RECOURSE_CAMPAIGN_DETAIL_ORDER_TYPE": "Order type",
  "RECOURSE_CAMPAIGN_DETAIL_OTHER_REVENUES": "Other revenues[€]",
  "RECOURSE_CAMPAIGN_DETAIL_OUTSTANDING_PARTIAL_PAYMENTS": "Partial Payments",
  "RECOURSE_CAMPAIGN_DETAIL_OUTSTANDING_REVENUES": "Outstanding revenues[€]",
  "RECOURSE_CAMPAIGN_DETAIL_PARTSREQUEST": "Partsrequest",
  "RECOURSE_CAMPAIGN_DETAIL_PARTSREQUEST_QPP": "Partsrequest QPP",
  "RECOURSE_CAMPAIGN_DETAIL_PUBLISHED_DATE": "Published date",
  "RECOURSE_CAMPAIGN_DETAIL_RECOURSE_REQUEST": "Recourse request",
  "RECOURSE_CAMPAIGN_DETAIL_RECOURSE_REQUEST_CHANGE_DATE": "Change date",
  "RECOURSE_CAMPAIGN_DETAIL_REVENUES_CURRENT_BUSINESS_YEAR": "Revenues current business year[€]",
  "RECOURSE_CAMPAIGN_DETAIL_REVENUES_PREVIOUS_YEARS": "Revenues previous years[€]",
  "RECOURSE_CAMPAIGN_DETAIL_SUPPLIER": "Creditor No.",
  "RECOURSE_CAMPAIGN_DETAIL_TABLE_BOOKING_ID": "Booking Id",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_AMOUNT": "Amount",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_BOOKING_TYPE": "Booking Type",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_CREDITOR": "Creditor",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_CREDITOR_NO": "Creditor No.",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_DUE_DATE": "Due Date",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_HEADLINE": "Partial Payments",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_STATE": "Status",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_TOTAL_AMOUNT": "Total amount[€]",
  "RECOURSE_CAMPAIGN_DETAIL_TARGET_CARS": "Target cars",
  "RECOURSE_CAMPAIGN_DETAIL_TOPIC": "Topic",
  "RECOURSE_CAMPAIGN_DETAIL_TOTAL_REVENUES": "Total Revenues[€]",
  "RECOURSE_CAMPAIGN_DETAIL_YEAR": "Business year",
  "RECOURSE_CAMPAIGN_OVERVIEW_TAB": "Overview",
  "RECOURSE_CAMPAIGN_TAB": "Campaigns",
  "RECOURSE_CAMPAIGN_TABLE_ASSIGNEE": "Assig.",
  "RECOURSE_CAMPAIGN_TABLE_CAMPAIGN_COSTS_PROGNOSIS": "Prog. costs",
  "RECOURSE_CAMPAIGN_TABLE_CAMPAIGN_ORIGINAL": "Camp.Orig",
  "RECOURSE_CAMPAIGN_TABLE_CAMPAIGN_RECOURSE_ID": "ID",
  "RECOURSE_CAMPAIGN_TABLE_CAMPAIGN_STATE_TYPE": "I/E",
  "RECOURSE_CAMPAIGN_TABLE_CREATE_DATE": "Dat.",
  "RECOURSE_CAMPAIGN_TABLE_FKCAMPAIGN_STATE_ID": "State",
  "RECOURSE_CAMPAIGN_TABLE_FULFILLMENT_DEGREE": "Perf.",
  "RECOURSE_CAMPAIGN_TABLE_NAME1": "Cred.",
  "RECOURSE_CAMPAIGN_TABLE_OPERATION_ID": "Key",
  "RECOURSE_CAMPAIGN_TABLE_ORDER_TYPE": "Ord. type",
  "RECOURSE_CAMPAIGN_TABLE_RECOURSE_ACTUAL_COSTS": "Act. costs",
  "RECOURSE_CAMPAIGN_TABLE_SUPPLIER": "Cred. No.",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_ASSIGNEE": "Assignee",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_CAMPAIGN_COSTS_PROGNOSIS": "Prognosis target costs",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_CAMPAIGN_ORIGINAL": "Original",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_CAMPAIGN_RECOURSE_ID": "Campaign ID",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_CAMPAIGN_STATE_TYPE": "Internal/External",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_CREATE_DATE": "Date",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_FKCAMPAIGN_STATE_ID": "State",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_FULFILLMENT_DEGREE": "Degree of performance[%]",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_NAME1": "Creditor",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_OPERATION_ID": "Transaction key",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_ORDER_TYPE": "Order type",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_RECOURSE_ACTUAL_COSTS": "Recourse actual costs",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_SUPPLIER": "Creditor No.",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_TOPIC": "Topic",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_TOTAL_REVENUE": "Total revenue",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_YEAR": "Trading year",
  "RECOURSE_CAMPAIGN_TABLE_TOPIC": "Topic",
  "RECOURSE_CAMPAIGN_TABLE_TOTAL_REVENUE": "Tot. rev.",
  "RECOURSE_CAMPAIGN_TABLE_YEAR": "Year",
  "RECOURSE_CLAIM": "Recourse claim",
  "RECOURSE_CLAIM_DATE_OF_DISPATCH": "Recourse claim sent",
  "RECOURSE_CLAIM_SEARCH": "Search",
  "RECOURSE_CLAIM_SEARCH_ERROR_CONTENT": "The search has failed",
  "RECOURSE_CLAIM_SEARCH_ERROR_TITLE": "Error",
  "RECOURSE_CLAIM_SEARCH_OBJECT_CRITERIA": "Object Criteria",
  "RECOURSE_CLAIM_SEARCH_PART_NUMBER": "Spare Part Number",
  "RECOURSE_CLAIM_SEARCH_RECOURSE_STATE": "Recourse State",
  "RECOURSE_CLAIM_TAB": "Claim Overview",
  "RECOURSE_CLAIM_TABLE_ACCEPTANCE_FACTOR": "Acceptance Factor",
  "RECOURSE_CLAIM_TABLE_BARCODE": "Barcode",
  "RECOURSE_CLAIM_TABLE_CLAIM_ID": "Claim Number",
  "RECOURSE_CLAIM_TABLE_DEALER_NUMBER": "Dealer Number",
  "RECOURSE_CLAIM_TABLE_ID": "ID",
  "RECOURSE_CLAIM_TABLE_QUALITY_COMPLAINT_CLOSE_DATE": "Quality Complaint Close Date",
  "RECOURSE_CLAIM_TABLE_QUOTA_RELEVANT": "Quota Relevant",
  "RECOURSE_CLAIM_TABLE_RECOURSE_STATE": "Recourse State",
  "RECOURSE_CLAIM_TABLE_SPARE_PART_NUMBER": "Spare Part Number",
  "RECOURSE_CLAIM_TABLE_SUPPLIER_NUMBER": "Supplier",
  "RECOURSE_CLAIM_TABLE_VIN": "VIN",
  "recourseCriteria.comment": "Comment",
  "recourseCriteria.commentInvalidCharacters": "{ } characters are not allowed. < > are only allowed around mail addresses.",
  "recourseCriteria.dealerNumber": "Dealer Number",
  "recourseCriteria.dealerNumberShort": "Dealer Nr.",
  "recourseCriteria.id": "ID",
  "recourseCriteria.mileage": "Mileage",
  "recourseCriteria.mileageShort": "Mileage",
  "recourseCriteria.objectCriteriaGroup": "Object Criteria Group",
  "recourseCriteria.objectCriteriaGroupShort": "Obj.Crit.Grp.",
  "recourseCriteria.recourseRelevant": "Recourse Relevant",
  "recourseCriteria.recourseRelevantShort": "Recourse",
  "recourseCriteria.sparePartNumber": "Spare Part Number",
  "recourseCriteria.sparePartNumberShort": "Spare Part Nr.",
  "recourseCriteria.supplierNumber": "Supplier Number",
  "recourseCriteria.supplierNumberShort": "Supplier",
  "recourseCriteria.tab": "Recourse Criteria",
  "recourseCriteria.validFrom": "Validity Date (from)",
  "recourseCriteria.validTo": "Validity Date (to)",
  "recourseCriteria.warrantyCalculationMethod": "Warranty Calculation Method",
  "recourseCriteria.warrantyCalculationMethodShort": "Warranty Calc.",
  "recourseCriteria.warrantyDays": "Warranty Days",
  "recourseCriteria.warrantyDaysShort": "Warranty Days",
  "recourseState.DEBITED": "Debited",
  "recourseState.NO_RECOURSE": "No recourse",
  "recourseState.OPEN": "Open",
  "recourseState.OUT_OF_WARRANTY": "Out of warranty",
  "recourseState.PART_REQUESTED": "Part requested",
  "recourseState.QUOTAS_ASSIGNED": "Quotas assigned",
  "recourseState.READY_FOR_DEBIT": "Ready for debit",
  "recourseState.WAITING_FOR_ANALYSIS": "Waiting for analysis",
  "REFERENCE": "Reference",
  "REFERENCE_BOOKINGS": "Reference bookings",
  "REFERENCED_BOOKING_AMOUNT": "Amount",
  "REFERENCED_BOOKING_DUE_DATE": "Due date",
  "REFERENCED_BOOKING_ID": "Booking Id",
  "REFERENCED_BOOKING_STATUS": "Status",
  "REFERENCED_BOOKING_SUM_AMOUNT": "Total amount",
  "REFERENCED_BOOKING_TYPE": "Booking type",
  "REJECT": "Reject",
  "REJECT_APPROVAL_DIALOG_REJECT_COMMENT": "Reject comment",
  "REJECT_BOOKING_FAILED": "Booking {{0}} could not be rejected.",
  "REJECT_BOOKING_FAILED_MESSAGE": "Rejection failed: Booking {{0}} could not be rejected.",
  "REJECT_BOOKING_FAILED_TITLE": "Rejection failed",
  "REJECT_BOOKING_MESSAGE": "Booking rejected: Booking {{0}} successfully rejected.",
  "REJECT_BOOKING_SUCCESSFUL": "Booking {{0}} is successfully rejected.",
  "REJECT_BOOKING_TITLE": "Booking rejected",
  "REJECTED": "Rejected",
  "REPLACEMENT_MOBILITY": "Replacement mobility",
  "REPORT_MODAL_TEXTFIELD_LABEL_SAVE": "Name of view",
  "REPROCESS_BOOKING_FAILED": "Booking {{0}} could not be reprocessed.",
  "REPROCESS_BOOKING_SUCCESSFUL": "Booking {{0}} is approved and reprocessed.",
  "REPROCESS_DIALOG_MESSAGE": "Booking will be reprocessed. Do you still want to continue?",
  "REPROCESS_DIALOG_TITLE": "Reprocess",
  "RESULTS": "results",
  "SALES_ORG_INVOICE_BLOCK": "Debitor is blocked for invoices in sales organization",
  "SALES_ORG_ORDER_BLOCK": "Debitor is blocked for orders in sales organization",
  "SAVE": "Save",
  "SAVE_ADDITIONAL_COST_ERROR_MESSAGE": "Additional costs for audit report {{0}} could not be saved.",
  "SAVE_ADDITIONAL_COST_ERROR_TITLE": "Error saving Additional costs",
  "SAVE_ADDITIONAL_COST_SUCCESS_MESSAGE": "Additional costs for audit report {{0}} successfully saved.",
  "SAVE_ADDITIONAL_COST_SUCCESS_TITLE": "Additional costs saving",
  "SAVE_BOOKING_FAILED_MESSAGE": "Booking could not be saved",
  "SAVE_BOOKING_FAILED_TITLE": "Booking Failed",
  "SAVE_ERROR_COST_RATE_ERROR_DUPLICATE_MESSAGE": "Error code {{0}} already exists. Saving not possible.",
  "SAVE_ERROR_COST_RATE_ERROR_MESSAGE": "Error code {{0}} could not be saved.",
  "SAVE_ERROR_COST_RATE_ERROR_TITLE": "Saving error code failed",
  "SAVE_ERROR_COST_RATE_SUCCESS_MESSAGE": "Error code {{0}} is successfully saved.",
  "SAVE_ERROR_COST_RATE_SUCCESS_TITLE": "Error code saved",
  "SAVED_CAMPAIGN_FAILED": "Campaign {{0}} could not be saved.",
  "SAVED_CAMPAIGN_SUCCESSFUL": "Campaign {{0}} successfully saved.",
  "SAVED_NEW_BOOKING_FAILED": "Booking/s {{0}} could not be saved.",
  "SAVED_NEW_BOOKING_SUCCESSFUL": "Booking/s {{0}} is/are successfully saved.",
  "SAVED_NEW_BOOKING_TITLE": "Saved",
  "SAVED_SUCCESSFUL": "Saved successful",
  "SAVED_TITLE": "Saved",
  "SEARCH": "Search",
  "SEARCH_CONFIGURATION": "Search configuration",
  "SEARCH_CRITERIA": "Search Criteria",
  "SELECT_INVOICE_REASON": "Select invoice reason",
  "START_APPROVE_PROCESS_BUTTON": "Start approval workflow",
  "STATUS_REASON_TEXT_PREFIX": "SAP-Error message: ",
  "SUPPLIER_EXCEPTIONS_CONFIRMATION_DIALOG": "Overwriting existing Supplier Exception",
  "SUPPLIER_EXCEPTIONS_CONFIRMATION_DIALOG_DELETE": "Deletion of exception of supplier",
  "SUPPLIER_EXCEPTIONS_CONFIRMATION_DIALOG_DELETE_MESSAGE": "Do you really want to delete the exception of supplier {{0}}?",
  "SUPPLIER_EXCEPTIONS_CONFIRMATION_DIALOG_MESSAGE": "Do you really want to overwrite existing data?",
  "SUPPLIER_EXCEPTIONS_DIALOG_DELETED_ERROR_MESSAGE": "Exception of a supplier from supplier {{0}} was not deleted.",
  "SUPPLIER_EXCEPTIONS_DIALOG_DELETED_ERROR_TITLE": "Deleting was not possible, error occurred",
  "SUPPLIER_EXCEPTIONS_DIALOG_DELETED_MESSAGE": "Exception of a supplier from supplier {{0}} was deleted.",
  "SUPPLIER_EXCEPTIONS_DIALOG_DELETED_TITLE": "Supplier exception deleted.",
  "SUPPLIER_EXCEPTIONS_DIALOG_EXCLUSION_FROM": "Exclusion from",
  "SUPPLIER_EXCEPTIONS_DIALOG_EXCLUSION_REASON": "Reason",
  "SUPPLIER_EXCEPTIONS_DIALOG_EXCLUSION_TILL": "Exclusion till",
  "SUPPLIER_EXCEPTIONS_DIALOG_NEW_BUTTON": "New exception of a supplier",
  "SUPPLIER_EXCEPTIONS_DIALOG_SAVED": "Exception of a supplier {{0}} was saved.",
  "SUPPLIER_EXCEPTIONS_DIALOG_SAVED_ERROR_MESSAGE": "Saving not possible. Exception of supplier already exists.",
  "SUPPLIER_EXCEPTIONS_DIALOG_SUPPLIER_NUMBER": "Supplier No",
  "SUPPLIER_EXCEPTIONS_DIALOG_TITLE": "Add/Edit new exclusion of a supplier",
  "SUPPLIER_EXCEPTIONS_REASON": "Reason",
  "SUPPLIER_EXCEPTIONS_TABLE_EXCLUSION_FROM": "Exclusion from",
  "SUPPLIER_EXCEPTIONS_TABLE_EXCLUSION_TILL": "Exclusion till",
  "SUPPLIER_EXCEPTIONS_TABLE_SUPPLIER": "Supplier",
  "SUPPLIER_EXCEPTIONS_TABLE_SUPPLIER_ID": "Supplier No.",
  "SUPPLIER_NOT_FOUND_MESSAGE": "Supplier does not exists or could not be found",
  "SUPPLIER_NOT_FOUND_TITLE": "Supplier not found",
  "SUPPLIER_SEARCH": "Supplier",
  "SUPPLIER_UPDATE_TITLE": "Supplier updated",
  "SUPPLIER_UPDATED_SUCCESSFUL": "Supplier was successfully updated",
  "supplierAnalysisAcceptance.ACCEPTED": "Accepted",
  "supplierAnalysisAcceptance.REJECTED": "Rejected",
  "supplierCondition.add": "Add Supplier Condition",
  "supplierCondition.createDate": "Creation Date",
  "supplierCondition.createDateShort": "Created on",
  "supplierCondition.delete.dialog.message": "Do you really want to delete selected Supplier Condition?",
  "supplierCondition.delete.dialog.title": "Delete Supplier Condition",
  "supplierCondition.delete.error.message": "Error deleting Supplier Condition",
  "supplierCondition.delete.success.message": "Supplier Condition successfully deleted",
  "supplierCondition.handlingChargeCostsFactor": "Handling Charge Costs (%)",
  "supplierCondition.handlingChargeCostsFactorShort": "% Handling C",
  "supplierCondition.handlingSupplierCostsFactor": "Handling Supplier Costs (%)",
  "supplierCondition.handlingSupplierCostsFactorShort": "% Handling S",
  "supplierCondition.laborCostsFactor": "Labor Costs (%)",
  "supplierCondition.laborCostsFactorShort": "% Labor",
  "supplierCondition.landingCostsFactor": "Landing Costs (%)",
  "supplierCondition.landingCostsFactorShort": "% Landing",
  "supplierCondition.lastEditDate": "Edit Date",
  "supplierCondition.lastEditDateShort": "Edited on",
  "supplierCondition.materialCostsFactor": "Material Costs (%)",
  "supplierCondition.materialCostsFactorShort": "% Material",
  "supplierCondition.modalTitle": "Create/Edit Supplier Condition",
  "supplierCondition.otherCosts": "Other costs in Euro",
  "supplierCondition.otherCosts.placeholder": "0.00",
  "supplierCondition.otherCostsShort": "€ Other",
  "supplierCondition.saveError.content": "Error when saving supplier condition",
  "supplierCondition.saveError.duplicateSupplier": "Supplier condition already exists",
  "supplierCondition.saveError.title": "Error",
  "supplierCondition.saveSuccess.content": "Supplier Condition saved",
  "supplierCondition.saveSuccess.title": "Success",
  "supplierCondition.supplierName": "Supplier Name",
  "supplierCondition.supplierNameShort": "Name",
  "supplierCondition.supplierNumber": "Supplier Number",
  "supplierCondition.supplierNumberShort": "Supplier",
  "supplierCondition.tab": "Supplier Condition",
  "supplierCondition.thirdPartyCostsFactor": "Third Party Costs (%)",
  "supplierCondition.thirdPartyCostsFactorShort": "% Third Party",
  "supplierCondition.thirdPartyMaterialCostsFactor": "Third Party Material Costs (%)",
  "supplierCondition.thirdPartyMaterialCostsFactorShort": "% Third Party Mat.",
  "TABLE_VIEW_DELETE_TABLE_VIEW": "Delete current view",
  "TABLE_VIEW_EDIT_TABLE_VIEW": "Edit current view",
  "TABLE_VIEW_MODAL_CONFIRMATION_MESSAGE": "Default view - Current default view '{{value}}' will be overwritten.",
  "TABLE_VIEW_MODAL_DEFAULT_VIEW": "Default view",
  "TABLE_VIEW_MODAL_DELETE_HEADER": "Delete current view",
  "TABLE_VIEW_MODAL_DELETE_MESSAGE": "The selected view '{{value}}' will be deleted, do you want to continue?",
  "TABLE_VIEW_MODAL_METADATA_CHANGED": "Metadata of the table has been changed. Save?",
  "TABLE_VIEW_MODAL_TEXTFIELD_LABEL_EDIT": "New name of view",
  "TABLE_VIEW_MODAL_TITLE_EDIT": "Edit current view",
  "TABLE_VIEW_MODAL_TITLE_SAVE": "Save current view",
  "TABLE_VIEW_RESET_TABLE_VIEW_DEFAULT": "Reset view (custom default)",
  "TABLE_VIEW_RESET_TABLE_VIEW_SYSTEM_DEFAULT": "Reset view (system default)",
  "TABLE_VIEW_SAVE_TABLE_VIEW": "Save view",
  "TABLE_VIEW_SAVE_TABLE_VIEW_TITLE": "Save current view",
  "TABLE_VIEW_SELECT_LABEL": "Table View",
  "TABLE_VIEW_SYSTEM_DEFAULT": "System default",
  "TABLE_VIEW_VALIDATOR_ALREADY_EXISTS": "View name already exists",
  "TABLE_VIEW_VALIDATOR_ENTER_NAME": "Specify view name",
  "TABLE_VIEW_VALIDATOR_INVALID_CHARACTERS": "Invalid character",
  "TABLE_VIEW_VALIDATOR_MAX_LENGTH": "Maximum length (50 characters) exceeded",
  "TABLE_VIEW_VALIDATOR_NOT_ALLOWED": "Nice try. Not allowed!",
  "TITLE_APPROVAL": "Approved",
  "TITLE_APPROVAL_WORKFLOW": "Approval process started",
  "TITLE_BOOKING_CANCELED": "Booking cancelled",
  "TITLE_DELETE_ATTACHMENT": "Attachment deleted",
  "TITLE_FAILED": "Failed",
  "TITLE_REJECT": "Rejected",
  "TITLE_REPROCESS": "Reprocess",
  "TITLE_SAVED": "Saved",
  "TITLE_UPLOAD_ATTACHMENT": "Attachment uploaded",
  "UPLOAD_ATTACHMENT": "Upload attachment",
  "UPLOAD_ATTACHMENT_CHOOSE": "Browse",
  "UPLOAD_ATTACHMENT_FAILED": "Attachment {{0}} could not be uploaded.",
  "UPLOAD_ATTACHMENT_FILE_SIZE": "The maximum file size of 15MB was exceeded.",
  "UPLOAD_ATTACHMENT_ONLY_PDF_MESSAGE": "Only .pdf can be external",
  "UPLOAD_ATTACHMENT_RECEIVER": "Receiver",
  "UPLOAD_ATTACHMENT_RECEIVER_EXTERN": "External",
  "UPLOAD_ATTACHMENT_RECEIVER_INTERN": "Internal",
  "UPLOAD_ATTACHMENT_SUCCESSFUL": "Attachment {{0}} is successfully uploaded.",
  "UPLOAD_ATTACHMENT_TITLE": "Add attachment",
  "UPLOAD_FAILED_TITLE": "Upload failed",
  "VALIDATION_INPUT_REQUIRED": "Required input",
  "validation.message.pattern": "This value is invalid",
  "validation.message.required": "This value is required",
  "warrantyCalculationMethod.CUSTOMER_DELIVERY": "start: delivery date",
  "warrantyCalculationMethod.ZP8": "start: production date",
  "WIDGET_SELECT_NO_RESULT_TEXT": "no result",
  "WIDGET_SELECT_PLACEHOLDER": "Please choose or type",
  "YES": "Yes",
  "yesno.no": "No",
  "yesno.yes": "Yes"
}
